import { authenticationContext, sessionManagement } from '@codametrix/ui-common';
import {
  clearCsrfToken,
  stopSessionHeartbeatScheduler
} from '@codametrix/client-session';

/**
 * Another tab logged out under FRONTEND_SESSION_FIRST and the server session is
 * already destroyed (the broadcast is sent after POST /logout). This tab's
 * in-memory and sessionStorage state belongs to that dead session, so stop the
 * timers that would otherwise renew / heartbeat against it, drop everything the
 * tab persisted, and leave through a hard navigation — the same exit the
 * initiating tab takes — so a fresh load runs the unauthenticated bootstrap.
 *
 * Deliberately does not dispatch `logout()`: that action is broadcast on the
 * auth channel and would echo back out to peers.
 */
export function handleSessionLoggedOut(
  navigate: () => void = () => {
    window.location.href = '/';
  }
): void {
  sessionManagement.activityMonitor.stop();
  stopSessionHeartbeatScheduler();
  clearCsrfToken();
  authenticationContext.setToken('');
  window.sessionStorage.clear();
  navigate();
}
